import * as Yup from "yup";

export const createUserInitialValues = {
  user_type: "",
  stack_holder_type: "",
  stack_holder_id: "",
  role_id: "",
  name: "",
  email: "",
  phone_no: "",
  password: "",
  status: undefined,
};

export const editUserInitialValues = {
  user_type: "",
  stack_holder_type: "",
  stack_holder_id: "",
  role_id: "",
  name: "",
  email: "",
  phone_no: "",
  status: undefined,
};

export const createAdminUserValidationSchema = Yup.object().shape({
  user_type: Yup.string().required("User Type is required"),
  stack_holder_type: Yup.string().nullable(),
  stack_holder_id: Yup.string().nullable(),
  role_id: Yup.string().required("role is required"),
  name: Yup.string().required("Name is required"),
  email: Yup.string().required("Email is required"),
  password: Yup.string().required("Password is required"),
  status: Yup.string().required("Status is required"),
});

export const createStackHolderUserValidationSchema = Yup.object().shape({
  user_type: Yup.string().required("User Type is required"),
  stack_holder_type: Yup.string().required("Stack holder type is required"),
  stack_holder_id: Yup.string().required("Stack holder is required"),
  role_id: Yup.string().notRequired(),
  name: Yup.string().required("Name is required"),
  email: Yup.string().required("Email is required"),
  password: Yup.string().required("Password is required"),
  status: Yup.string().required("Status is required"),
});

export const editAdminUserValidationSchema = () => {
  return createAdminUserValidationSchema.omit(["password"]);
};

export const editStackHolderUserValidationSchema = () => {
  return createStackHolderUserValidationSchema.omit(["password"]);
};
